export const SITE_NAME = "大学吃瓜";
export const SITE_SLOGAN = "校园情感瓜料，现场直击，天天更新";
export const SITE_DESC =
  "大学吃瓜官网汇集大学生恋爱故事、情侣纠纷、表白现场、分手内幕、情感纠葛、三角关系等校园情感八卦，最新现场直击，天天更新。";

export const HOT_TOPICS = [
  "毕业季异地恋：六百公里真的挡得住爱情吗",
  "图书馆搭讪法则：隔着一本书怎么开口",
  "朋友圈公开官宣，为什么反而闹分手",
  "情侣该不该共用一张校园卡",
  "前任同框选修课，全程高能现场",
  "社团晚会上台表白，被拒后社死现场",
];

export interface ColumnItem {
  slug: string;
  name: string;
  en: string;
  desc: string;
  tagline: string;
  image: string;
}

export const COLUMNS: ColumnItem[] = [
  {
    slug: "lianai",
    name: "恋爱故事",
    en: "Love Story",
    desc: "从相识到相恋的点滴，甜度超标的校园恋爱实录。",
    tagline: "甜度直冒泡",
    image:
      "https://readdy.ai/api/search-image?query=soft%20sunset%20campus%20pathway%20with%20two%20silhouettes%20walking%20together%2C%20warm%20coral%20and%20cream%20pastel%20tones%2C%20dreamy%20bloom%20photography%2C%20gentle%20film%20grain%2C%20romantic%20atmosphere&width=900&height=620&seq=col-love&orientation=landscape",
  },
  {
    slug: "biaobai",
    name: "表白现场",
    en: "Confession",
    desc: "晚自习、操场、跨年烟火……那些脸红心跳的公开告白。",
    tagline: "心跳全公开",
    image:
      "https://readdy.ai/api/search-image?query=campus%20night%20party%20with%20fairy%20lights%20and%20confetti%2C%20happy%20crowd%20cheering%2C%20warm%20golden%20and%20red%20bokeh%2C%20lively%20festival%20mood%2C%20editorial%20candid%20photography&width=900&height=620&seq=col-conf&orientation=landscape",
  },
  {
    slug: "fenshou",
    name: "分手内幕",
    en: "Breakup",
    desc: "冷战、异地、毕业分岔路……复盘那些戛然而止的感情。",
    tagline: "一句算了吧",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20empty%20campus%20bench%20under%20ginkgo%20tree%20at%20dusk%2C%20falling%20leaves%2C%20melancholy%20soft%20lighting%2C%20muted%20sage%20and%20amber%20tones%2C%20cinematic%20moody%20photography&width=900&height=620&seq=col-break&orientation=landscape",
  },
  {
    slug: "jiufen",
    name: "情侣纠纷",
    en: "Quarrel",
    desc: "AA 制分歧、游戏与电话之争、共享账号闹剧……相处难题。",
    tagline: "相处有难题",
    image:
      "https://readdy.ai/api/search-image?query=two%20coffee%20cups%20on%20campus%20cafe%20table%20with%20notebooks%2C%20bright%20morning%20window%20light%2C%20fresh%20green%20and%20cream%20palette%2C%20clean%20lifestyle%20photography&width=900&height=620&seq=col-quarrel&orientation=landscape",
  },
  {
    slug: "jiegao",
    name: "三角纠葛",
    en: "Triangle",
    desc: "前任新欢、暧昧三人局、实习组暗涌……复杂关系现场。",
    tagline: "剪不断理还乱",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20intertwined%20ribbons%20in%20three%20warm%20colors%20coral%20gold%20green%20on%20soft%20cream%20background%2C%20minimal%20artistic%203d%20render%2C%20gentle%20shadows%2C%20clean%20composition&width=900&height=620&seq=col-tri&orientation=landscape",
  },
];